import { IJxtModalFooter } from './types';

const JxtModalFooter = ({ children }: IJxtModalFooter) => (
  <footer className="flex items-center justify-end gap-2 border-t border-neutral-20 p-4 min-h-[72px] shrink-0">
    {children}
  </footer>
);

export default JxtModalFooter;
